import * as React from "react";
const SvgFiRrFeatherPointed = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-feather-pointed_svg__a)">
      <path
        fill="#062147"
        d="M23.298.7a2.38 2.38 0 0 0-2.052-.673c-3.629.548-10.529 2.282-15.97 7.74a7.82 7.82 0 0 0-2.267 5.853 7.7 7.7 0 0 0 1.585 4.371l-4.3 4.302a.999.999 0 1 0 1.413 1.414l4.304-4.304a7.56 7.56 0 0 0 4.665 1.604 8.13 8.13 0 0 0 5.832-2.488c5.443-5.622 7.03-12.912 7.46-15.785A2.36 2.36 0 0 0 23.3.7M5.008 13.53A5.81 5.81 0 0 1 6.692 9.18c5.036-5.052 11.468-6.663 14.854-7.174.023-.004.215-.039.34.108a.39.39 0 0 1 .105.323c-.18 1.2-.578 3.226-1.41 5.562h-3.923a4.97 4.97 0 0 0-3.535 1.465L6.03 16.556a5.74 5.74 0 0 1-1.02-3.026zm13.222-.53h-5.815l2.121-2.122A3.02 3.02 0 0 1 16.657 10h3.126a27 27 0 0 1-1.553 3m-3.158 4.127c-2.077 2.146-5.337 2.464-7.625.84L10.415 15h6.465a22 22 0 0 1-1.808 2.128"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-feather-pointed_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFeatherPointed;
